// extracted by mini-css-extract-plugin
module.exports = {"body":"SignUp_body__2JlUJ","have_account":"SignUp_have_account__tFyu9","footer":"SignUp_footer__1o-Dw"};